import { PatientAbsenceActions, PatientAbsenceActionTypes } from "./patient-absence.action";
import { PatientAbsence } from "@featuresAY/patient-web-ay/models/patient-absence.model";

export interface PatientAbsenceState {
	patientAbsences: PatientAbsence[];
	loading: boolean;
	loaded: boolean;
	error: any;
}

export const initialState: PatientAbsenceState = {
	patientAbsences: [],
	loading: false,
	loaded: false,
	error: null,
};

export function patientAbsenceReducer(state = initialState, action: PatientAbsenceActions): PatientAbsenceState {
	switch (action.type) {
		case PatientAbsenceActionTypes.LoadPatientAbsence:
		case PatientAbsenceActionTypes.CreatePatientAbsence:
		case PatientAbsenceActionTypes.UpdatePatientAbsence:
		case PatientAbsenceActionTypes.DeletePatientAbsence:
			return { ...state, loading: true, loaded: false };
		case PatientAbsenceActionTypes.LoadPatientAbsenceSuccess:
			return { ...state, patientAbsences: action.payload, loading: false, loaded: true };
		case PatientAbsenceActionTypes.CreatePatientAbsenceSuccess:
		case PatientAbsenceActionTypes.UpdatePatientAbsenceSuccess:
		case PatientAbsenceActionTypes.DeletePatientAbsenceSuccess:
			return { ...state, loaded: true, loading: false };
		case PatientAbsenceActionTypes.LoadPatientAbsenceError:
		case PatientAbsenceActionTypes.CreatePatientAbsenceError:
		case PatientAbsenceActionTypes.UpdatePatientAbsenceError:
		case PatientAbsenceActionTypes.DeletePatientAbsenceError:
			return { ...state, error: action.payload, loaded: false, loading: false };
		default:
			return state;
	}
}
